import { useCallback } from 'react';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import ChapterNavigation from '@components/transcript/ChapterNavigation';

export default function ChapterNavigationController({ chapters }) {
  const { seekTo, play, isPlaying } = useAudioPlayer();
  const onChapterClick = useCallback((startTime) => {
    seekTo(startTime);
    if (!isPlaying) {
      play();
    }
  }, [isPlaying, play, seekTo]);

  return <ChapterNavigation chapters={chapters} onChapterClick={onChapterClick} />;
}
